module.exports = __webpack_public_path__ + "static/media/hands-helping.c01542ab.svg";